import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { dateFormat } from 'formatters/date';
import { IManual } from 'interfaces/manual';
import GarbageIcon from 'mdi-react/GarbageIcon';
import React, { memo } from 'react';

interface IProps {
  manual: IManual;
  handleRemove: () => void;
}

const ListItem = (props: IProps) => {
  const { manual, handleRemove } = props;

  return (
    <TableRow>
      <TableCell>
        <Link
          target="blank"
          rel="noopener noreferrer"
          href={manual.url}
        >
          {manual.name && manual.name}
        </Link>
      </TableCell>
      <TableCell align="right">
        {manual.createdDate ? dateFormat(new Date(manual.createdDate)) : '-'}
      </TableCell>
      <TableCell align="right">
        <IconButton size="small" onClick={handleRemove}>
          <GarbageIcon color="#30009C" size={20} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default memo<IProps>(ListItem);